<template>
  <div class="bar-sticky-bottom-container">
    <slot name="content"></slot>
  </div>
</template>

<script>
export default {
  name: 'BarStickyBottom',
  props: {
    show: { type: Boolean, default: false },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .bar-sticky-bottom-container {
    position: fixed;
    right: 0;
    left: 0;
    bottom: 0;
    height: 57px;
    background-color: #005cbf;
    z-index: 10000;
  }
</style>



// WEBPACK FOOTER //
// src/components/utils/BarStickyBottom.vue